import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import Timeline, { Note } from '../../../components/Timeline';
import { ErrorScreen, Loading } from '../../../components/utils';
import { NotebookContext } from '../../../context/NotebookContext';
import { notesQuery } from '../../../queries/notes';
import { NotesQuery, NotesQueryVariables } from '../../../queries/__generated__/NotesQuery';
import EmptyState from './EmptyState';

const NotebookTimeline: React.FunctionComponent = () => {
  const { notebook } = useContext(NotebookContext);

  return (
    <Query<NotesQuery, NotesQueryVariables>
      query={notesQuery}
      variables={{
        input: {
          notebookId: notebook.id,
          first: 20
        }
      }}
    >
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          return <ErrorScreen error={error.message} />;
        }

        let notes: Note[] = [];
        if (data!.notes.edges) {
          notes = data!.notes.edges.map(e => e!.node!);
        }

        return (
          <>
            {!!notes.length && (
              <div className="mv4">
                <Timeline notes={notes} />
              </div>
            )}

            {notes.length === 0 && <EmptyState />}
          </>
        );
      }}
    </Query>
  );
};

export default NotebookTimeline;
